import Title from 'components/summary/Title/styled';

export default Title;
